<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow mt-0">
            <div
              class="card-header card-header-primary negative blue-grad w-50 d-flex"
            >
              <button class="btn btn-sm btn-link" @click="$router.go(-1)">
                <i class="fa fa-chevron-left"></i> {{ $t("message.back") }}
              </button>
              <h4 class="card-title">
                {{ $t("message.admin.serviceprices") }}
              </h4>
            </div>
            <div class="card-body px-3">
              <div class="d-flex mb-3 justify-content-between">
                <!-- <router-link :to="{name: 'admin-index'}" class="btn btn-sm btn-outline-primary" >{{$t('message.back')}}</router-link> -->
                <button
                  class="btn btn-sm btn-outline-success"
                  @click="addService"
                >
                  {{ $t("message.add") }}
                </button>
              </div>

              <b-table
                :items="services"
                :fields="service_fields"
                :per-page="per_page"
                :current-page="current_page"
              >
                <template v-slot:cell(number)="data">
                  {{ data.index + 1 }}
                </template>
                <template v-slot:cell(billing_service_price)="data">
                  {{ rubleFormat(data.value, data) }}
                </template>
                <template v-slot:cell(service_price_privileged)="data">
                  {{ rubleFormat(data.value, data) }}
                </template>
                <template v-slot:cell(billing_service_cur)="data">
                  {{ displayCurrency(data.item.billing_service_cur) }}
                </template>
                <template v-slot:cell(active)="data">
                  <div class="btn-group">
                    <button
                      class="btn btn-sm btn-info"
                      @click="editService(data.item)"
                    >
                      <i class="fa fa-edit"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-danger"
                      @click="deleteService(data.item)"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </template>
              </b-table>
              <div class="d-flex justify-content-center">
                <b-pagination
                  v-model="current_page"
                  :total-rows="services_length"
                  :per-page="per_page"
                  aria-controls="my-table"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-add-service"
      :hide-footer="true"
      size="sm"
      :title="$t('message.admin.add_service')"
      button-size="lg"
    >
      <div class="form-gro2up mb-3">
        <label for="offer_file">
          {{ $t("message.admin.service_code") }}
        </label>
        <input type="text" v-model="service_code" class="form-control" />
      </div>
      <div class="form-gro2up mb-3">
        <label for="offer_file">
          {{ $t("message.admin.service_name") }}
        </label>
        <input type="text" v-model="service_name" class="form-control" />
      </div>
      <div class="form-gro2up mb-3">
        <label for="offer_file">
          {{ $t("message.admin.service_price") }}
        </label>
        <input type="number" v-model="service_price" class="form-control" />
      </div>
      <div class="form-gro2up mb-3">
        <label for="offer_file">
          {{ $t("message.admin.service_price_privileged") }}
        </label>
        <input
          type="number"
          v-model="service_price_privileged"
          class="form-control"
        />
      </div>
      <div class="form-gro2up mb-3">
        <label for="offer_file">
          {{ $t("message.admin.service_price") }}
        </label>
        <v-select-popup
          type="currency"
          v-model="service_currency"
          :placeholder="$t('message.contracts.currency')"
        />
      </div>
      <div class="text-center">
        <button @click="confirm_add()" class="btn btn-success btn-sm">
          {{ $t("message.add") }}
        </button>
      </div>
    </b-modal>
    <b-modal
      id="modal-edit-service"
      :hide-footer="true"
      size="sm"
      :title="$t('message.admin.add_service')"
      button-size="lg"
    >
      <div class="form-gro2up mb-3">
        <label for="offer_file">
          {{ $t("message.admin.service_code") }}
        </label>
        <input type="text" v-model="service_code" class="form-control" />
      </div>
      <div class="form-gro2up mb-3">
        <label for="offer_file">
          {{ $t("message.admin.service_name") }}
        </label>
        <input type="text" v-model="service_name" class="form-control" />
      </div>
      <div class="form-gro2up mb-3">
        <label for="offer_file">
          {{ $t("message.admin.service_price") }}
        </label>
        <input type="number" v-model="service_price" class="form-control" />
      </div>
      <div class="form-gro2up mb-3">
        <label for="offer_file">
          {{ $t("message.admin.service_price_privileged") }}
        </label>
        <input
          type="number"
          v-model="service_price_privileged"
          class="form-control"
        />
      </div>
      <div class="form-gro2up mb-3">
        <label for="offer_file">
          {{ $t("message.admin.service_price") }}
        </label>
        <v-select-popup
          type="currency"
          v-model="service_currency"
          :placeholder="$t('message.contracts.currency')"
        />
      </div>
      <div class="text-center">
        <button @click="confirm_edit()" class="btn btn-success btn-sm">
          {{ $t("message.save") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "admin-users",
  mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
    this.fetchCurrencies();
    this.load();
  },
  computed: {
    services_length() {
      return this.services.length;
    },
  },
  data() {
    return {
      service_id: -1,
      service_code: "",
      service_name: "",
      service_price: 0,
      service_price_privileged: 0,
      service_currency: "",

      currencies: [],

      current_page: 0,
      per_page: 20,
      services: [],
      topup_amount: 0,
      topup_user: -1,
      service_fields: [
        {
          key: "number",
          label: this.$t("message.contracts.documents_packaging_number"),
          sortable: true,
        },
        {
          key: "billing_service_code",
          label: this.$t("message.admin.service_code"),
          sortable: true,
        },
        {
          key: "billing_service_name_ru",
          label: this.$t("message.admin.service_name"),
          sortable: true,
        },
        {
          key: "billing_service_price",
          label: this.$t("message.admin.service_price"),
          sortable: true,
        },
        {
          key: "service_price_privileged",
          label: this.$t("message.admin.service_price_privileged"),
          sortable: true,
        },
        {
          key: "billing_service_cur",
          label: this.$t("message.contracts.currency"),
          sortable: true,
        },
        {
          key: "active",
          label: this.$t("message.admin.actions"),
          sortable: true,
        },
      ],
    };
  },
  methods: {
    rubleFormat(amount, data) {
      return window.rubFormat(amount, data.item.billing_service_cur);
    },
    displayCurrency(value) {
      return value;
      let currency = { display_text: "" };
      let index = this.currencies.findIndex((item) => item.value == value);
      if (index > -1) currency = this.currencies[index];

      return currency.display_text;
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
          // this.$data[var_name] = response.data
        });
    },
    fetchCurrencies() {
      this.getLibrary("currency", "", 100);
    },
    /**
     * Sends request to the backend to remove service from the database
     * @param {*} id
     */
    deleteService(id) {
      let fd = new FormData();
      fd.append("id", id.id);
      axios
        .post(window.base + "/account/deleteService", fd)
        .then((response) => {
          this.load();
          new Noty({
            theme: "light",
            type: "success",
            text: this.$root.$t("message.message.success"),
            timeout: 5000,
          }).show();
        })
        .catch((e) => {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$root.$t("message.message.no_success") + " (" + e + ")",
            timeout: 5000,
          }).show();
        });
    },
    /**
     * Sends request to the backend to create new record in the database of services
     */
    confirm_add() {
      let fd = new FormData();
      fd.append("service_code", this.service_code);
      fd.append("service_name", this.service_name);
      fd.append("service_currency", this.service_currency.value);
      fd.append("service_price", this.service_price);
      fd.append("service_price_privileged", this.service_price_privileged);
      axios
        .post(window.base + "/account/addService", fd)
        .then((response) => {
          this.$bvModal.hide("modal-add-service");
          this.load();
          new Noty({
            theme: "light",
            type: "success",
            text: this.$root.$t("message.message.success"),
            timeout: 5000,
          }).show();
        })
        .catch((e) => {
          this.$bvModal.hide("modal-add-service");
          new Noty({
            theme: "light",
            type: "error",
            text: this.$root.$t("message.message.no_success") + " (" + e + ")",
            timeout: 5000,
          }).show();
        });
    },
    /**
     * Sends request to the backend to update record in the database of services
     */
    confirm_edit() {
      let fd = new FormData();
      fd.append("id", this.service_id);
      fd.append("service_code", this.service_code);
      fd.append("service_currency", this.service_currency.value);
      fd.append("service_name", this.service_name);
      fd.append("service_price", this.service_price);
      fd.append("service_price_privileged", this.service_price_privileged);
      axios
        .post(window.base + "/account/editService", fd)
        .then((response) => {
          this.$bvModal.hide("modal-edit-service");
          this.load();
          new Noty({
            theme: "light",
            type: "success",
            text: this.$root.$t("message.message.success"),
            timeout: 5000,
          }).show();
        })
        .catch((e) => {
          this.$bvModal.hide("modal-edit-service");
          new Noty({
            theme: "light",
            type: "error",
            text: this.$root.$t("message.message.no_success") + " (" + e + ")",
            timeout: 5000,
          }).show();
        });
    },
    /**
     * Displays modal to update service record
     * @param {*} service
     */
    editService(service) {
      this.service_id = service.id;
      this.service_code = service.billing_service_code;
      this.service_name = service.billing_service_name_ru;
      this.service_currency = service.billing_service_currency;
      this.service_price = service.billing_service_price;
      this.service_price_privileged = service.service_price_privileged;
      this.$bvModal.show("modal-edit-service");
    },
    /**
     * Displays modal to add new service
     */
    addService() {
      this.service_code = "";
      this.service_name = "";
      this.service_price = 0;
      this.service_price_privileged = 0;
      this.$bvModal.show("modal-add-service");
    },
    /**
     * Fetches list of all services
     */
    load() {
      axios.get(window.base + "/account/GetServicesPrice").then((response) => {
        this.services = response.data; //.filter(i=>i.active==1)
      });
    },
  },
};
</script>
<style>
.page-item.active button {
  /* background: #9c27b0 !important; */
  /* color: #fff !important; */
}
</style>
